import { fetcher } from "helpers/fetcher";

import {
  TDeleteJobListingWorkingHoursReq,
  TDeleteJobListingWorkingHoursRes,
} from "./types";
import { API_HEADER } from "../constants";
import { ENDPOINT } from "../endpoint";

export const deleteJobListingWorkingHours = async (
  payload: TDeleteJobListingWorkingHoursReq
) => {
  return await fetcher<
    TDeleteJobListingWorkingHoursRes,
    TDeleteJobListingWorkingHoursReq["data"]
  >(ENDPOINT.CORPORATION.DELETE_JOB_LISTING_WORKING_HOURS, {
    data: payload.data,
    headers: {
      [API_HEADER.CORP_ID]: payload.idCorp,
    },
  });
};

export const mutationDeleteJobListingWorkingHours = async (
  payload: TDeleteJobListingWorkingHoursReq
) => {
  return (await deleteJobListingWorkingHours(payload)).data;
};

mutationDeleteJobListingWorkingHours._key = (
  payload: TDeleteJobListingWorkingHoursReq
) => [ENDPOINT.CORPORATION.DELETE_JOB_LISTING_WORKING_HOURS.url, payload];
